<template>
    <div class="sb-sug-mobile" @click="handleClk">
        <im-input
            ref="input"
            :readonly="true"
            customInputClass="customInputClass"
            :class="inputClass"
            :theme="theme"
        >
            <template #prepend>
                <div class="labels" :class="labelClass">
                    <div class="ellipse">{{ label }}</div>
                </div>
            </template>
            <template #append>
                <div class="drop_icon">
                    <span class="iconfont icon-arrow-down"></span>
                </div>
            </template>
        </im-input>
    </div>
</template>

<script>
import popMgr from '@/components/global/popMgr';
import SuggestionPop from './suggestion-pop.vue';
import mixin from './mixins';
import classNames from 'classnames';
export default {
    emits: ['change'],
    name: 'SuggestionMobile',
    mixins: [mixin],
    inject: {
        colorStyle: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        inputClass() {
            return classNames('container', this.theme);
        },
        labelClass() {
            return classNames(this.theme);
        },

        modelVal() {
            return this.value ? [...this.value] : [];
        },
        label() {
            return this.modelVal
                .map(m => {
                    return m.split(':')[1];
                })
                .join(',');
        }
    },
    methods: {
        handleClk() {
            popMgr.create(SuggestionPop, {
                parentIns: this,
                onClose: () => {
                    this.options = [];
                },
                onSelect: item => {
                    if (this.modelVal.some(m => m.value === item.value)) {
                        return; 
                    }
                    const value = [...this.modelVal, item.value];
                    // const valueObj = {};
                    // const labels = [];
                    // value.forEach(v => {
                    //     const type = v.type;
                    //     if (!valueObj[type]) {
                    //         valueObj[type] = [];
                    //     }
                    //     valueObj[type].push(v.value);
                    //     labels.push(v.value);
                    // });
                    const emitValue = {
                        value: value,
                        kee: this.kee,
                        type: 'suggestion'
                    };
                    this.$emit('change', emitValue);
                }
            });
        }
    }
};
</script>

<style lang="scss">
.sb-sug-mobile {
    height: 100%;
    .container {
        .drop_icon {
            display: flex;
            align-content: center;
            justify-content: center;
            @media screen and (max-width: 800px) {
                padding-right: 17px;
            }
            .iconfont {
                transition: transform 0.3s;
                &.rotate {
                    transform: rotate(180deg);
                }
            }
        }
        .labels {
            display: flex;
            justify-content: flex-start;
            overflow: hidden;
            max-width: 100%;
            padding-left: 10px;
            .ellipse {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        &.standard {
            .iconfont {
                font-size: 16px;
                color: #c6c8d1;
            }
        }
        &.template4 {
            .iconfont {
                font-size: 16px;
                color: #d6dae8;
            }
        }
        &.template1 {
            .iconfont {
                font-size: 16px;
                color: #c6c8d1;
            }
        }
    }
}
</style>
